export default "__VITE_ASSET__56c759b6__"